import Switch from '~/shared/components/Switch';
import Typography from '~/shared/components/Typography';
import { toaster } from '~/shared/utils/toaster';

interface OptimisticToggleSwitchProps {
  switchState: boolean;
  onSwitchClick: (newState: boolean) => void;
  isPending: boolean;
  canWrite: boolean;
}

export default function OptimisticToggleSwitch({
  switchState,
  onSwitchClick,
  isPending,
  canWrite,
}: OptimisticToggleSwitchProps) {

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCheckedState = e.target.checked;
    onSwitchClick(newCheckedState);
  };

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={switchState}
        onChange={handleSwitchChange}
        disabled={!canWrite || isPending}
      />
      <div>
        <Typography variant="p3" color="text-blue-600" className="font-medium">
          {switchState ? 'On' : 'Off'}
        </Typography>
      </div>
    </div>
  );
}
